<template>
  <nav class="c-cbr-Nav-outer">
    <ul class="c-cbr-Nav-links">
      <li
        v-if="languages"
        class="c-cbr-Nav-linksItem">
        <div class="c-cbr-FormField-select-wrapper">
          <label
            class="visually-hidden"
            for="language-select">
            Select Language
          </label>
          <select
            id="language-select"
            v-model="currentLanguage"
            class="c-cbr-Nav-lang-select c-cbr-FormField-input"
            @change="eventBus.$emit('keepSelectedCountry')">
            <option
              v-for="(label, lang) in languages"
              :key="lang"
              :value="lang">
              {{ label }}
            </option>
          </select>
        </div>
      </li>
    </ul>
  </nav>
</template>

<style>
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  clip: rect(0 0 0 0);
  overflow: hidden;
  white-space: nowrap;
}
</style>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { eventBus } from '../app'
import { i18nIsoCountriesVar } from '../store/modules/config/index'
export default {
  data() {
    return {
      eventBus,
      i18nIsoCountriesVar
    }
  },

  computed: {
    ...mapState('config', ['features']),
    ...mapGetters('lang', ['languages']),

    currentLanguage: {
      get: function() {
        return this.$store.state.lang.currentLanguage
      },
      set: function(val) {
        this.languageSelect(val)
      }
    }
  },

  watch: {
    currentLanguage: function(newLang) {
      this.updateHtmlLang(newLang)
    }
  },

  mounted() {
    // initialize the language:
    if (!(this.currentLanguage in this.languages)) {
      this.languageSelect((this.currentLanguage = 'en'))
    } else {
      this.languageSelect(this.currentLanguage)
    }

    // Set the initial value of the lang attribute
    this.updateHtmlLang(this.currentLanguage)
  },

  methods: {
    ...mapActions('lang', ['languageSelect']),
    updateHtmlLang(lang) {
      document.documentElement.setAttribute('lang', lang)
    }
  }
}
</script>



// WEBPACK FOOTER //
// client/components/CbrNavigation.vue